<template>
    <div class="project_info_box">
        <div class="project_info">
            <div class="search_box">
                <div class="box_line">
                    <div class="search-btn upload_green" @click="fnOpenAddWin" v-if="!tableData.length">
                        <span>添加项目信息</span>
                    </div>
                    <div class="search-btn upload_green" @click="fnUploadProjectToGzs"><span>上传至贵州省人社厅</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">项目类型</div>
                    <div class="title_item">是否备案</div>
                    <div class="title_item">项目地址</div>
                    <div class="title_item">项目状态</div>
                    <div class="title_item">项目（计划）开工日期</div>
                    <div class="title_item">项目（计划）竣工日期</div>
                    <div class="title_item">上传状态</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="tableData">
                            <div class="box_line" v-for="(item, index) in tableData" :key="index">
                                <div class="list_item">{{ item.category }}</div>
                                <div class="list_item">{{ item.isRegistered }}</div>
                                <div class="list_item">{{ item.projectDetailedAddress }}</div>
                                <div class="list_item">{{ item.status }}</div>
                                <div class="list_item">{{ item.planStartDate }}</div>
                                <div class="list_item">{{ item.planCompleteDate }}</div>
                                <div class="list_item">{{ item.upload_at ? '已上传——' + item.upload_at : '未上传' }}</div>
                                <div class="list_item">
                                    <div>
                                        <div class="search-btn" v-if="!item.upload_at" @click="fnOpenEditWin(false)">
                                            <span>编辑</span>
                                        </div>
                                        <div class="search-btn" v-else @click="fnOpenEditWin(true)"><span>详情</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 添加、编辑参建单位弹窗 -->
            <div class="wrap-project" v-if="showUnit">
                <el-dialog title="编辑项目信息" top="5vh" :custom-class="'animate__animated animate__fadeIn'" :modal="false"
                    :visible.sync="showUnit" center width="80%">
                    <div style="width: 100%">
                        <el-tabs style="height: 100%">
                            <el-tab-pane label="项目信息（* 必填）" value="0">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">*项目合同签订日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="project.contractSigningDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*签约合同价（万元）</div>
                                            <div class="row-item">
                                                <el-input v-model="project.contractPrice"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目（计划）开工日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="project.planStartDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目（计划）竣工日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="project.planCompleteDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目（实际）开工日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="project.startDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">项目（实际）竣工日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="project.completeDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">
                                                *经度
                                                <!-- <a href="https://lbs.amap.com/console/show/picker" style="font-size: 12px;color: blue" target="_blank">（点击拾取经纬度）</a> -->
                                                <a href="javascript:void(0);" style="font-size: 12px;color: blue"
                                                    @click="showMap = true">（点击拾取经纬度）</a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="project.lon"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*纬度</div>
                                            <div class="row-item">
                                                <el-input v-model="project.lat"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目状态</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.status" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="筹备" value="筹备"></el-option>
                                                    <el-option label="在建" value="在建"></el-option>
                                                    <el-option label="完工" value="完工"></el-option>
                                                    <el-option label="停工" value="停工"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">
                                                *所在区域编码
                                                <a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html"
                                                    style="font-size: 12px;color: #0080FF" target="_blank">
                                                    （查看所在区域编码）
                                                </a>
                                                <br />
                                                <a href="http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E8%B4%B5%E5%B7%9E%E7%9C%81%E7%89%B9%E6%AE%8A%E5%8C%BA%E5%9F%9F%E7%A0%81.xls"
                                                    style="font-size: 12px;color: #0080FF">
                                                    (下载贵州省特殊区域编码)
                                                </a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="project.projectAddress"
                                                    placeholder="12位行政区划分码,如520115000000(以0补足12位)"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目地址</div>
                                            <div class="row-item">
                                                <el-input v-model="project.projectDetailedAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目分类</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.category" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option v-for="item in GZS.category" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*是否政府投资项目</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.govInvest" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="是" value="是"></el-option>
                                                    <el-option label="否" value="否"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*是否在贵州省建筑业监管和公共服务平台备案</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.isRegistered" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="是" value="是"></el-option>
                                                    <el-option label="否" value="否"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*行业主管部门</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.subordinateDepartments"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="住房建设" value="住房建设"></el-option>
                                                    <el-option label="交通运输" value="交通运输"></el-option>
                                                    <el-option label="非煤矿山" value="非煤矿山"></el-option>
                                                    <el-option label="水利" value="水利"></el-option>
                                                    <el-option label="电力" value="电力"></el-option>
                                                    <el-option label="通讯" value="通讯"></el-option>
                                                    <el-option label="农业农村" value="农业农村"></el-option>
                                                    <el-option label="自然资源" value="自然资源"></el-option>
                                                    <el-option label="铁路建设" value="铁路建设"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目主管部门</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.projectDepartments" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="住建" value="住建"></el-option>
                                                    <el-option label="科技教育" value="科技教育"></el-option>
                                                    <el-option label="医疗卫生" value="医疗卫生"></el-option>
                                                    <el-option label="文化旅游" value="文化旅游"></el-option>
                                                    <el-option label="民政" value="民政"></el-option>
                                                    <el-option label="司法" value="司法"></el-option>
                                                    <el-option label="公安" value="公安"></el-option>
                                                    <el-option label="生态环保" value="生态环保"></el-option>
                                                    <el-option label="工信" value="工信"></el-option>
                                                    <el-option label="乡村振兴" value="乡村振兴"></el-option>
                                                    <el-option label="生态移民" value="生态移民"></el-option>
                                                    <el-option label="港口与航道" value="港口与航道"></el-option>
                                                    <el-option label="高速公路" value="高速公路"></el-option>
                                                    <el-option label="国省干线" value="国省干线"></el-option>
                                                    <el-option label="农村公路" value="农村公路"></el-option>
                                                    <el-option label="基建" value="基建"></el-option>
                                                    <el-option label="生产经营" value="生产经营"></el-option>
                                                    <el-option label="其他" value="其他"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*是否购买工伤保险</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.isInsurance" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="是" value="是"></el-option>
                                                    <el-option label="否" value="否"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目保障金预存金额，最低5万，单位为万元</div>
                                            <div class="row-item">
                                                <el-input v-model="project.securityPayments"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*劳资专管员姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="project.labourSpecialName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*劳资专管员电话</div>
                                            <div class="row-item">
                                                <el-input v-model="project.labourSpecialPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*劳资专管员身份证号码</div>
                                            <div class="row-item">
                                                <el-input v-model="project.labourSpecialIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*发薪日期</div>
                                            <div class="row-item">
                                                <el-input v-model="project.payDate" placeholder="1-2位正整数字符(无符号)">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*联系人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="project.linkPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*联系人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="project.linkPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">项目简介</div>
                                            <div class="row-item">
                                                <el-input v-model="project.description"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">项目备案编号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.recordId"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">工程立项批准文号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.approvalNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设工程规划许可证编号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.prjectPlanNum"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设用地规划许可证编号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.buildPlanNum"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总投资（万元）</div>
                                            <div class="row-item">
                                                <el-input v-model="project.invest"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总面积（平方米）</div>
                                            <div class="row-item">
                                                <el-input v-model="project.buildingArea"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">标段编号(如交通类必填)</div>
                                            <div class="row-item">
                                                <el-input v-model="project.bidNum"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">合同编号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.contractNo"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">项目总工期</div>
                                            <div class="row-item">
                                                <el-input v-model="project.totalDate"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">工程用途</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.projectPurposes" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.projectPurposes" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">项目所属行业主管部门所在地行政区划代码</div>
                                            <div class="row-item">
                                                <el-input v-model="project.subordinateDepartmentsCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">工伤参保编号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.insuranceNum"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">工伤保险凭证</div>
                                            <div class="row-item">
                                                <el-input v-model="project.insuranceEvidence"></el-input>
                                            </div>
                                        </div>
                                        <div class="row" style="height:164px">
                                            <div class="row-item" style="line-height: 150px;">*维权告示牌凭证</div>
                                            <div class="row-item">
                                                <el-upload class="avatar-uploader" action="" list-type="picture-card"
                                                    :http-request="
                                                        res => {
                                                            beforeCardPicUpload(res.file, 'safeguardCertificateUrl');
                                                        }
                                                    " :show-file-list="false">
                                                    <img style="width: 100%; height: 100%;"
                                                        v-if="project.safeguardCertificateUrl"
                                                        :src="project.safeguardCertificateUrl" class="avatar" />
                                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">资金来源</div>
                                            <div class="row-item">
                                                <el-input v-model="project.capitalSource"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">立项文号</div>
                                            <div class="row-item">
                                                <el-input v-model="project.approvalReferenceNum"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">立项级别</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.approvalLevelNum" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="部级" value="部级"></el-option>
                                                    <el-option label="省级" value="省级"></el-option>
                                                    <el-option label="区县级" value="区县级"></el-option>
                                                    <el-option label="国家级" value="国家级"></el-option>
                                                    <el-option label="其他" value="其他"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设规模</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.projectScale" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="大型" value="大型"></el-option>
                                                    <el-option label="中型" value="中型"></el-option>
                                                    <el-option label="小型" value="小型"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设性质</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.projectNature" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.projectNature" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*项目保障金类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="project.securityPaymentsType"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="现金" value="现金"></el-option>
                                                    <el-option label="保险保函" value="保险保函"></el-option>
                                                    <el-option label="银行保函" value="银行保函"></el-option>
                                                    <el-option label="免缴" value="免缴"></el-option>
                                                    <el-option label="业主缴" value="业主缴"></el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">项目保障金附件</div>
                                            <div class="row-item">
                                                <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                                    :file-list="securityPaymentsExemptUrlList"
                                                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove3"
                                                    :http-request=" res => { beforeCardPicUpload(res.file, 'securityPaymentsExemptUrl');}">
                                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>

                                                <el-dialog :visible.sync="dialogVisible" :modal="false">
                                                    <img width="100%" :src="dialogImageUrl" alt="">
                                                </el-dialog>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="总承包单位信息（* 必填）" value="1">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 总承包单位信息开始 -->
                                        <div class="row">
                                            <div class="row-item">*总承包单位项目经理姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.projectManager"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位项目经理联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.projectManagerPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位项目经理证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.projectManagerIdCardNum">
                                                </el-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">*总承包单位项目责任人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.principalName">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位项目责任人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.principalNamePhone">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位项目责任人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.principalNameIdCardNum">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位在项目中的承建状态</div>
                                            <div class="row-item">
                                                <el-select size="small"
                                                    v-model="orgGeneralContractor.constructionStatus" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="进场" value="进场"></el-option>
                                                    <el-option label="退场" value="退场"></el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">*总承包单位进场时间</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgGeneralContractor.approachDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位企业事业单位名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.orgName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位统一社会信用代码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.orgCreditCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位成立日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgGeneralContractor.registerDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">
                                                *总承包单位注册地行政区划代码
                                                <a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html"
                                                    style="font-size: 12px;color: #0080FF" target="_blank">
                                                    （查看所在区域编码）
                                                </a>
                                                <br />
                                                <a href="http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E8%B4%B5%E5%B7%9E%E7%9C%81%E7%89%B9%E6%AE%8A%E5%8C%BA%E5%9F%9F%E7%A0%81.xls"
                                                    style="font-size: 12px;color: #0080FF">
                                                    (下载贵州省特殊区域编码)
                                                </a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.registerAddressCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位邮政编码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.postalCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位注册地址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.registerAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位法定代表人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.legalPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位法定代表人职务</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.legalPersonDuty"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位法定代表人职称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.legalPersonProTitle"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位单位类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.orgType"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.orgType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位经济类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.economyType"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.economyType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位隶属关系</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.affiliation"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.affiliation" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位经营方式</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.operateType"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.operateType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位资本币种</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.capitalCurrency"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.capitalCurrency" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位工商注册号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.orgLicenseRegistCode">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位法定代表人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.legalPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位法定代表人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.legalPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">登记注册类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.registerType"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.registerType" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位劳资负责人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.laborerPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位劳资负责人公民身份证号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.laborerPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位劳资负责人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.laborerPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位所属行业</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.industry"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.industry" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位联系人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.contactPerson"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位联系人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.contactPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位传真号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.faxNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位办公号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.officeNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位办公地址(营业地址)</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.officeAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位注册日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgGeneralContractor.registDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位企业网址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.webSite"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位企业邮箱</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.email"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位银行名称</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgGeneralContractor.bankName"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.bankName" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位银行卡号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.bankAccount"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位银行支行名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.bankBranchName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位银行联号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.bankAffiliated"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*总承包单位注册资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.registerCapital"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">总承包单位实收资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgGeneralContractor.paidinCapital"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="建设单位信息（* 必填）" value="2">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 建设单位信息 -->
                                        <div class="row">
                                            <div class="row-item">*建设单位企业事业单位名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.orgName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位统一社会信用代码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.orgCreditCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位项目经理姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.projectManager"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位项目经理联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.projectManagerPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位项目经理证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.projectManagerIdCardNum"></el-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">建设单位项目责任人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.principalName">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位项目责任人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.principalNamePhone">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位项目责任人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.principalNameIdCardNum">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位在项目中的承建状态</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.constructionStatus" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="进场" value="进场"></el-option>
                                                    <el-option label="退场" value="退场"></el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">建设单位进场时间</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgOwner.approachDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位工商注册号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.orgLicenseRegistCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位法定代表人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.legalPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位法定代表人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.legalPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位法定代表人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.legalPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位法定代表人职务</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.legalPersonDuty"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位法定代表人职称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.legalPersonProTitle"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.orgType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.orgType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位经济类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.economyType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.economyType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位隶属关系</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.affiliation" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.affiliation" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位经营方式</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.operateType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.operateType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位资本币种</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.capitalCurrency" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.capitalCurrency" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位成立日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgOwner.registerDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">
                                                *建设单位注册地行政区划代码
                                                <a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html"
                                                    style="font-size: 12px;color: #0080FF" target="_blank">
                                                    （查看所在区域编码）
                                                </a>
                                                <br />
                                                <a href="http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E8%B4%B5%E5%B7%9E%E7%9C%81%E7%89%B9%E6%AE%8A%E5%8C%BA%E5%9F%9F%E7%A0%81.xls"
                                                    style="font-size: 12px;color: #0080FF">
                                                    (下载贵州省特殊区域编码)
                                                </a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.registerAddressCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位邮政编码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.postalCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位注册地址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.registerAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位登记注册类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.registerType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.registerType" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位劳资负责人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.laborerPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位劳资负责人公民身份证号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.laborerPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位劳资负责人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.laborerPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位所属行业</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.industry" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.industry" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位联系人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.contactPerson"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位联系人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.contactPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位传真号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.faxNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位办公号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.officeNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位办公地址(营业地址)</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.officeAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位注册日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgOwner.registDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位企业网址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.webSite"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位企业邮箱</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.email"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位银行名称</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgOwner.bankName" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.bankName" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位银行卡号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.bankAccount"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位银行支行名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.bankBranchName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位银行联号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.bankAffiliated"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*建设单位注册资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.registerCapital"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">建设单位实收资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgOwner.paidinCapital"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="项目施工许可证（住建行业必填）" value="9">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 项目进度人工费用结算 -->
                                        <div class="row">
                                            <div class="row-item">*施工许可证号</div>
                                            <div class="row-item">
                                                <el-input v-model="constructionPermit.permitNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*施工许可证发证日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="constructionPermit.permitStartDate"
                                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*施工许可证到期日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="constructionPermit.permitEndDate"
                                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">施工许可证原件</div>
                                            <div class="row-item">
                                                <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                                    :file-list="constructionPermitList"
                                                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove4"
                                                    :http-request=" res => { beforeCardPicUpload(res.file, 'constructionPermit');}">
                                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>

                                                <el-dialog :visible.sync="dialogVisible" :modal="false">
                                                    <img width="100%" :src="dialogImageUrl" alt="">
                                                </el-dialog>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="项目进度人工费用结算" value="7">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 项目进度人工费用结算 -->
                                        <div class="row">
                                            <div class="row-item">*施工合同原件</div>
                                            <div class="row-item">
                                                <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                                    :file-list="contractAppendixList"
                                                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                                                    :http-request=" res => { beforeCardPicUpload(res.file, 'contractAppendix');}">
                                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>

                                                <el-dialog :visible.sync="dialogVisible" :modal="false">
                                                    <img width="100%" :src="dialogImageUrl" alt="">
                                                </el-dialog>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*累计结算日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="projectSettlement.settlementDate"
                                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*累计结算周期（天）</div>
                                            <div class="row-item">
                                                <el-input v-model="projectSettlement.settlementCycle"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*累计结算金额（万元）</div>
                                            <div class="row-item">
                                                <el-input v-model="projectSettlement.settlementAmount"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="项目工程款支付担保" value="8">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 项目工程款支付担保 -->
                                        <div class="row">
                                            <div class="row-item">*担保单位统一社会信用代码</div>
                                            <div class="row-item">
                                                <el-input v-model="projectPaySecurity.securityOrgCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*担保单位名称</div>
                                            <div class="row-item">
                                                <el-input v-model="projectPaySecurity.securityOrgName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*担保开始日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="projectPaySecurity.securityStartDate"
                                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*担保结束日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="projectPaySecurity.securityEndDate"
                                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*担保金额（元）</div>
                                            <div class="row-item">
                                                <el-input v-model="projectPaySecurity.securityPrice"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="工资专户信息" value="3">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 工资专户信息 -->
                                        <div class="row">
                                            <div class="row-item">*所属银行</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="wageAccount.bank" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.bankName" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*开户名称</div>
                                            <div class="row-item">
                                                <el-input v-model="wageAccount.accountName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*开户类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="wageAccount.accountType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="专户" value="专户"></el-option>
                                                    <el-option label="一般户" value="一般户"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*专户类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="wageAccount.specialAccountType"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="实体户" value="实体户"></el-option>
                                                    <el-option label="虚拟户" value="虚拟户"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*工资发放渠道</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="wageAccount.salaryPayChannel"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="第三方" value="第三方"></el-option>
                                                    <el-option label="银行" value="银行"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*开户账号</div>
                                            <div class="row-item">
                                                <el-input v-model="wageAccount.accountNo"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*开户银行支行名称</div>
                                            <div class="row-item">
                                                <el-input v-model="wageAccount.bankName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*账户余额（元）</div>
                                            <div class="row-item">
                                                <el-input v-model="wageAccount.accountBalance"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">工资专户三方协议</div>
                                            <div class="row-item">
                                                <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                                    :file-list="tripartiteAgreementList"
                                                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove2"
                                                    :http-request=" res => { beforeCardPicUpload(res.file, 'tripartiteAgreement');}">
                                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                                </el-upload>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="设计单位信息" value="4">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 设计单位信息 -->
                                        <div class="row">
                                            <div class="row-item">*设计单位企业事业单位名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.orgName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位统一社会信用代码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.orgCreditCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位项目经理姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.projectManager"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位项目经理联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.projectManagerPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位项目经理证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.projectManagerIdCardNum"></el-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">*设计单位项目责任人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.principalName">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位项目责任人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.principalNamePhone">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位项目责任人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.principalNameIdCardNum">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位在项目中的承建状态</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.constructionStatus"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="进场" value="进场"></el-option>
                                                    <el-option label="退场" value="退场"></el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">设计单位进场时间</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgDesign.approachDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位工商注册号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.orgLicenseRegistCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位法定代表人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.legalPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位法定代表人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.legalPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位法定代表人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.legalPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位法定代表人职务</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.legalPersonDuty"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位法定代表人职称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.legalPersonProTitle"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.orgType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.orgType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位经济类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.economyType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.economyType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位隶属关系</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.affiliation" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.affiliation" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位经营方式</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.operateType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.operateType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位资本币种</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.capitalCurrency" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.capitalCurrency" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位成立日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgDesign.registerDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">
                                                *设计单位注册地行政区划代码
                                                <a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html"
                                                    style="font-size: 12px;color: #0080FF" target="_blank">
                                                    （查看所在区域编码）
                                                </a>
                                                <br />
                                                <a href="http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E8%B4%B5%E5%B7%9E%E7%9C%81%E7%89%B9%E6%AE%8A%E5%8C%BA%E5%9F%9F%E7%A0%81.xls"
                                                    style="font-size: 12px;color: #0080FF">
                                                    (下载贵州省特殊区域编码)
                                                </a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.registerAddressCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位邮政编码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.postalCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*设计单位注册地址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.registerAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位登记注册类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.registerType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.registerType" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位劳资负责人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.laborerPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位劳资负责人公民身份证号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.laborerPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位劳资负责人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.laborerPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位所属行业</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.industry" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.industry" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位联系人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.contactPerson"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位联系人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.contactPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位传真号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.faxNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位办公号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.officeNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位办公地址(营业地址)</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.officeAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位注册日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgDesign.registDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位企业网址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.webSite"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位企业邮箱</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.email"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位银行名称</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgDesign.bankName" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.bankName" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位银行卡号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.bankAccount"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位银行支行名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.bankBranchName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位银行联号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.bankAffiliated"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位注册资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.registerCapital"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">设计单位实收资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgDesign.paidinCapital"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="监理单位信息" value="5">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 监理单位信息 -->
                                        <div class="row">
                                            <div class="row-item">*监理单位企业事业单位名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.orgName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位统一社会信用代码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.orgCreditCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位项目经理姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.projectManager"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位项目经理联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.projectManagerPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位项目经理证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.projectManagerIdCardNum"></el-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">*监理单位项目责任人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.principalName">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位项目责任人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.principalNamePhone">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位项目责任人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.principalNameIdCardNum">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位在项目中的承建状态</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.constructionStatus"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="进场" value="进场"></el-option>
                                                    <el-option label="退场" value="退场"></el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">监理单位进场时间</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgSupervision.approachDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位工商注册号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.orgLicenseRegistCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位法定代表人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.legalPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位法定代表人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.legalPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位法定代表人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.legalPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位法定代表人职务</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.legalPersonDuty"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位法定代表人职称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.legalPersonProTitle"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.orgType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.orgType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位经济类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.economyType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.economyType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位隶属关系</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.affiliation" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.affiliation" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位经营方式</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.operateType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.operateType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位资本币种</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.capitalCurrency"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.capitalCurrency" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位成立日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgSupervision.registerDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">
                                                *监理单位注册地行政区划代码
                                                <a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html"
                                                    style="font-size: 12px;color: #0080FF" target="_blank">
                                                    （查看所在区域编码）
                                                </a>
                                                <br />
                                                <a href="http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E8%B4%B5%E5%B7%9E%E7%9C%81%E7%89%B9%E6%AE%8A%E5%8C%BA%E5%9F%9F%E7%A0%81.xls"
                                                    style="font-size: 12px;color: #0080FF">
                                                    (下载贵州省特殊区域编码)
                                                </a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.registerAddressCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位邮政编码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.postalCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*监理单位注册地址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.registerAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位登记注册类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.registerType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.registerType" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位劳资负责人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.laborerPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位劳资负责人公民身份证号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.laborerPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位劳资负责人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.laborerPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位所属行业</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.industry" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.industry" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位联系人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.contactPerson"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位联系人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.contactPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位传真号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.faxNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位办公号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.officeNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位办公地址(营业地址)</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.officeAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位注册日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgSupervision.registDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位企业网址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.webSite"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位企业邮箱</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.email"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位银行名称</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSupervision.bankName" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.bankName" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位银行卡号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.bankAccount"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位银行支行名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.bankBranchName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位银行联号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.bankAffiliated"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位注册资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.registerCapital"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">监理单位实收资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSupervision.paidinCapital"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <el-tab-pane label="勘察单位信息" value="6">
                                <div class="pane_box">
                                    <div class="left-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <!-- 勘察单位信息 -->
                                        <div class="row">
                                            <div class="row-item">*勘察单位企业事业单位名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.orgName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位统一社会信用代码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.orgCreditCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位项目经理姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.projectManager"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位项目经理联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.projectManagerPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位项目经理证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.projectManagerIdCardNum"></el-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">*勘察单位项目责任人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.principalName">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位项目责任人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.principalNamePhone">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位项目责任人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.principalNameIdCardNum">
                                                </el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位在项目中的承建状态</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.constructionStatus"
                                                    filterable placeholder="请选择" style="border-radius: 0;">
                                                    <el-option label="请选择" value></el-option>
                                                    <el-option label="进场" value="进场"></el-option>
                                                    <el-option label="退场" value="退场"></el-option>
                                                </el-select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">勘察单位进场时间</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgSurvey.approachDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位工商注册号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.orgLicenseRegistCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位法定代表人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.legalPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位法定代表人证件号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.legalPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位法定代表人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.legalPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位法定代表人职务</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.legalPersonDuty"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位法定代表人职称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.legalPersonProTitle"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.orgType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.orgType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位经济类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.economyType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.economyType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位隶属关系</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.affiliation" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.affiliation" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位经营方式</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.operateType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.operateType" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位资本币种</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.capitalCurrency" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.capitalCurrency" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位成立日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgSurvey.registerDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right-item item">
                                        <div class="row">
                                            <div class="row-item">
                                                参数说明
                                                <span style="color:#F56C6C;">（* 必填）</span>
                                            </div>
                                            <div class="row-item">参数值</div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">
                                                *勘察单位注册地行政区划代码
                                                <a href="http://www.mca.gov.cn/article/sj/xzqh/1980/201803/201803131454.html"
                                                    style="font-size: 12px;color: #0080FF" target="_blank">
                                                    （查看所在区域编码）
                                                </a>
                                                <br />
                                                <a href="http://cqxtkj.oss-cn-chengdu.aliyuncs.com/Trivia/%E8%B4%B5%E5%B7%9E%E7%9C%81%E7%89%B9%E6%AE%8A%E5%8C%BA%E5%9F%9F%E7%A0%81.xls"
                                                    style="font-size: 12px;color: #0080FF">
                                                    (下载贵州省特殊区域编码)
                                                </a>
                                            </div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.registerAddressCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位邮政编码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.postalCode"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">*勘察单位注册地址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.registerAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位登记注册类型</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.registerType" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.registerType" :key="item"
                                                        :label="item" :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位劳资负责人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.laborerPersonName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位劳资负责人公民身份证号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.laborerPersonIdCard"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位劳资负责人联系电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.laborerPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位所属行业</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.industry" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.industry" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位联系人姓名</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.contactPerson"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位联系人电话</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.contactPersonPhone"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位传真号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.faxNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位办公号码</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.officeNumber"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位办公地址(营业地址)</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.officeAddress"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位注册日期</div>
                                            <div class="row-item">
                                                <el-date-picker v-model="orgSurvey.registDate"
                                                    value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                                    placeholder="选择日期时间"></el-date-picker>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位企业网址</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.webSite"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位企业邮箱</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.email"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位银行名称</div>
                                            <div class="row-item">
                                                <el-select size="small" v-model="orgSurvey.bankName" filterable
                                                    placeholder="请选择" style="border-radius: 0;">
                                                    <el-option v-for="item in GZS.bankName" :key="item" :label="item"
                                                        :value="item"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位银行卡号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.bankAccount"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位银行支行名称</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.bankBranchName"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位银行联号</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.bankAffiliated"></el-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="row-item">勘察单位注册资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.registerCapital"></el-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="row-item">勘察单位实收资本（ 元 ）</div>
                                            <div class="row-item">
                                                <el-input v-model="orgSurvey.paidinCapital"></el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showUnit = false"><span>关 闭</span></div>
                            <div class="search-btn" @click="fnAddOrEdit"><span>保 存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <!-- 项目信息上传结果弹窗上传 -->
            <el-dialog title="上传错误" center :visible.sync="isShowUploadResult" top="5vh">
                <el-table :data="resultData">
                    <el-table-column property="result">
                        <template slot-scope="scope">
                            <span :class="[scope.row.code == 0 ? 'warning-row' : null]">{{ scope.row.result }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" type="success" @click="isShowUploadResult = false">关 闭</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="dialog_setMap" v-if="showMap">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :close-on-click-modal="false"
                :modal="false" title="获取经纬度" :visible.sync="showMap" center>
                <div class="show_map">
                    <GDMaps @fnGetLocation="fnGetLocation"></GDMaps>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="showMap = false"><span>关 闭</span></div>
                        <div class="search-btn" @click="fnGetLocationYes"><span>确 定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    import APP from '@/utils/base';
    import request from '@/utils/request';
    import GZS from '@/configure/gzs';
    import {
        fnUpload
    } from '@/utils/upload';
    import {
        Loading
    } from 'element-ui';
    import {
        fnCookie
    } from '@/utils/localStorage';
    import * as imageConversion from 'image-conversion';
    import GDMaps from '@/components/Map/location.vue';
    import {
        getUserInfo
    } from '@/utils/auth'
    export default {
        data() {
            return {
                isShowDetails: false, // 弹窗
                isShowUploadResult: false, // 上传结果弹窗
                resultData: [], // 上传结果数据
                showUnit: false, // 编辑弹窗
                tableData: [], // 表格数据
                projectData: [],
                GZS: GZS,
                isEdit: true,
                editProjectId: null, // 编辑项目信息id
                editOrgGeneralContractorId: null, // 编辑总承包单位id
                editOrgOwnerId: null, // 编辑建设单位id
                editWageAccountId: null, // 编辑工资专户id
                editOrgDesignId: null, // 编辑设计单位id
                editOrgSupervisionId: null, // 编辑监理单位id
                editOrgSurveyId: null, // 编辑勘察单位id
                editProjectSettlementId: null, // 编辑项目进度人工费用结算id
                editProjectPaySecurityId: null, // 编辑项目工程款支付担保id
                editConstructionPermitId: null, // 编辑项项目施工许可证id
                project: {
                    // 项目信息
                    category: null, // 项目类型
                    govInvest: null, // 是否政府投资项目
                    isRegistered: null, // 是否备案
                    projectAddress: null, // 行政区划分码
                    projectDetailedAddress: null, // 项目地址
                    lon: null, // 经度
                    lat: null, // 纬度
                    status: null, // 项目状态
                    contractSigningDate: null, // 项目合同签订日期
                    contractPrice: null, // 签约合同价（万元）
                    planStartDate: null, // 项目（计划）开工日期
                    planCompleteDate: null, // 项目（计划）开工日期
                    startDate: null, // 项目（实际）开工日期
                    completeDate: null, // 项目（实际）竣工日期
                    linkPersonName: null, // 联系人姓名
                    linkPersonPhone: null, // 联系人电话
                    subordinateDepartments: null, // 项目所属行业主管部门所在地行政区划代码
                    isInsurance: null, // 是否购买工伤保险
                    securityPayments: null, // 项目保障金预存金额，最低5万，单位为万元
                    labourSpecialName: null, // 劳资专管员姓名
                    labourSpecialPhone: null, // 劳资专管员电话
                    labourSpecialIdCard: null, // 劳资专管员身份证号码
                    payDate: null, // 发薪日期
                    permitNumber: null, // 施工许可证号(住建行业必填)
                    description: null, // 项目简介
                    recordId: null, // 工程立项批准文号
                    approvalNumber: null, // 工程立项批准文号
                    prjectPlanNum: null, // 建设用地规划许可证编号
                    buildPlanNum: null, // 建设用地规划许可证编号
                    invest: null, // 总投资（万元）
                    buildingArea: null, // 总面积（平方米）
                    bidNum: null, // 标段编号(如交通类必填)
                    contractNo: null, // 合同编号
                    totalDate: null, // 项目总工期
                    capitalSource: null, // 资金来源
                    approvalReferenceNum: null, // 立项文号
                    approvalLevelNum: null, // 立项级别
                    projectScale: null, // 建设规模
                    projectNature: null, // 建设性质
                    projectPurposes: null, // 工程用途
                    subordinateDepartmentsCode: null, // 项目所属行业主管部门所在地行政区划代码
                    insuranceNum: null, // 工伤参保编号
                    insuranceEvidence: null, // 工伤保险凭证
                    safeguardCertificateUrl: null, // 维权告示牌凭证
                    securityPaymentsType: null, // 项目保障金类型
                    securityPaymentsExemptUrl: null // 项目保障金附件地址
                },
                orgGeneralContractor: {
                    // 总承包单位
                    projectManager: null, // 参建单位项目经理姓名
                    projectManagerPhone: null, // 参建单位项目经理联系电话
                    projectManagerIdCardNum: null, // 参建单位项目经理证件号码
                    principalName: null, // 参建单位项目责任人姓名
                    principalNamePhone: null, // 参建单位项目责任人联系电话
                    principalNameIdCardNum: null, // 参建单位项目责任人证件号码
                    constructionStatus: null, // 参建单位在项目中的承建状态
                    approachDate: null, // 总承包单位进场时间
                    orgName: null, // 总承包单位企业事业单位名称
                    orgCreditCode: null, // 总承包单位统一社会信用代码
                    registerAddress: null, // 总承包单位注册地行政区划代码
                    orgLicenseRegistCode: null, // 总承包单位工商注册号
                    legalPersonName: null, // 总承包单位法定代表人姓名
                    legalPersonIdCard: null, // 总承包单位法定代表人证件号码
                    legalPersonPhone: null, // 总承包单位法定代表人电话
                    legalPersonDuty: null, // 总承包单位法定代表人职务
                    legalPersonProTitle: null, // 总承包单位法定代表人职称
                    orgType: null, // 总承包单位单位类型
                    economyType: null, // 总承包单位经济类型
                    affiliation: null, // 总承包单位隶属关系
                    operateType: null, // 总承包单位经营方式
                    registerCapital: null, // 总承包单位注册资本（ 元 ）
                    paidinCapital: null, // 总承包单位实收资本（ 元 ）
                    capitalCurrency: 'CNY-人民币元', // 总承包单位资本币种
                    registerDate: null, // 总承包单位成立日期
                    registerAddressCode: null, // 总承包单位注册地行政区划代码
                    postalCode: null, // 总承包单位邮政编码
                    registerType: null, // 登记注册类型
                    laborerPersonName: null, // 总承包单位劳资负责人姓名
                    laborerPersonIdCard: null, // 总承包单位劳资负责人公民身份证号码
                    laborerPersonPhone: null, // 总承包单位劳资负责人联系电话
                    industry: null, // 总承包单位所属行业
                    contactPerson: null, // 总承包单位联系人姓名
                    contactPersonPhone: null, // 总承包单位联系人电话
                    faxNumber: null, // 总承包单位传真号码
                    officeNumber: null, // 总承包单位办公号码
                    officeAddress: null, // 总承包单位办公地址(营业地址)
                    registDate: null, // 总承包单位注册日期
                    webSite: null, // 总承包单位企业网址
                    email: null, // 总承包单位企业邮箱
                    bankName: null, // 总承包单位银行名称
                    bankAccount: null, // 总承包单位银行卡号
                    bankBranchName: null, // 总承包单位银行支行名称
                    bankAffiliated: null // 总承包单位银行联号
                },
                orgOwner: {
                    // 建设单位
                    orgName: null, // 建设单位企业事业单位名称
                    orgCreditCode: null, // 建设单位统一社会信用代码
                    projectManager: null, // 建设单位项目经理姓名
                    projectManagerPhone: null, // 建设单位项目经理联系电话
                    projectManagerIdCardNum: null, // 建设单位项目经理证件号码
                    principalName: null, // 参建单位项目责任人姓名
                    principalNamePhone: null, // 参建单位项目责任人联系电话
                    principalNameIdCardNum: null, // 参建单位项目责任人证件号码
                    constructionStatus: null, // 参建单位在项目中的承建状态
                    approachDate: null, // 建设单位进场时间
                    orgLicenseRegistCode: null, // 建设单位工商注册号
                    legalPersonName: null, // 建设单位法定代表人姓名
                    legalPersonIdCard: null, // 建设单位法定代表人证件号码
                    legalPersonPhone: null, // 建设单位法定代表人电话
                    legalPersonDuty: null, // 建设单位法定代表人职务
                    legalPersonProTitle: null, // 建设单位法定代表人职称
                    orgType: null, // 建设单位类型
                    economyType: null, // 建设单位经济类型
                    affiliation: null, // 建设单位隶属关系
                    operateType: null, // 建设单位经营方式
                    registerCapital: null, // 建设单位注册资本（ 元 ）
                    paidinCapital: null, // 建设单位实收资本（ 元 ）
                    capitalCurrency: 'CNY-人民币元', // 建设单位资本币种
                    registerDate: null, // 建设单位成立日期
                    registerAddressCode: null, // 建设单位注册地行政区划代码
                    registerAddress: null, // 注册地址
                    postalCode: null, // 建设单位邮政编码
                    registerType: null, // 建设单位登记注册类型
                    laborerPersonName: null, // 建设单位劳资负责人姓名
                    laborerPersonIdCard: null, // 建设单位劳资负责人公民身份证号码
                    laborerPersonPhone: null, // 建设单位劳资负责人联系电话
                    industry: null, // 建设单位所属行业
                    contactPerson: null, // 建设单位联系人姓名
                    contactPersonPhone: null, // 建设单位联系人电话
                    faxNumber: null, // 建设单位传真号码
                    officeNumber: null, // 建设单位办公号码
                    officeAddress: null, // 建设单位办公地址(营业地址)
                    registDate: null, // 建设单位注册日期
                    webSite: null, // 建设单位企业网址
                    email: null, // 建设单位企业邮箱
                    bankName: null, // 建设单位银行名称
                    bankAccount: null, // 建设单位银行卡号
                    bankBranchName: null, // 建设单位银行支行名称
                    bankAffiliated: null // 建设单位银行联号
                },
                wageAccount: {
                    // 工资专户
                    bank: null, // 所属银行
                    accountName: null, // 开户名称
                    accountType: null, // 开户类型
                    specialAccountType: null, // 专户类型
                    salaryPayChannel: null, // 工资发放渠道
                    accountNo: null, // 开户账号
                    bankName: null, // 开户银行支行名称
                    accountBalance: null, // 账户余额（元）
                    tripartiteAgreementUrl: null, // 工资专户三方协议
                },
                orgDesign: {
                    // 设计单位
                    orgName: null, // 设计单位企业事业单位名称
                    orgCreditCode: null, // 设计单位统一社会信用代码
                    projectManager: null, // 设计单位项目经理姓名
                    projectManagerPhone: null, // 设计单位项目经理联系电话
                    projectManagerIdCardNum: null, // 设计单位项目经理证件号码
                    principalName: null, // 参建单位项目责任人姓名
                    principalNamePhone: null, // 参建单位项目责任人联系电话
                    principalNameIdCardNum: null, // 参建单位项目责任人证件号码
                    constructionStatus: null, // 参建单位在项目中的承建状态
                    approachDate: null, // 设计单位进场时间
                    orgLicenseRegistCode: null, // 设计单位工商注册号
                    legalPersonName: null, // 设计单位法定代表人姓名
                    legalPersonIdCard: null, // 设计单位法定代表人证件号码
                    legalPersonPhone: null, // 设计单位法定代表人电话
                    legalPersonDuty: null, // 设计单位法定代表人职务
                    legalPersonProTitle: null, // 设计单位法定代表人职称
                    orgType: null, // 设计单位类型
                    economyType: null, // 设计单位经济类型
                    affiliation: null, // 设计单位隶属关系
                    operateType: null, // 设计单位经营方式
                    registerCapital: null, // 建设单位注册资本（ 元 ）
                    paidinCapital: null, // 建设单位实收资本（ 元 ）
                    capitalCurrency: 'CNY-人民币元', // 设计单位资本币种
                    registerDate: null, // 设计单位成立日期
                    registerAddressCode: null, // 设计单位注册地行政区划代码
                    registerAddress: null, // 注册地址
                    postalCode: null, // 设计单位邮政编码
                    registerType: null, // 设计单位登记注册类型
                    laborerPersonName: null, // 设计单位劳资负责人姓名
                    laborerPersonIdCard: null, // 设计单位劳资负责人公民身份证号码
                    laborerPersonPhone: null, // 设计单位劳资负责人联系电话
                    industry: null, // 设计单位所属行业
                    contactPerson: null, // 设计单位联系人姓名
                    contactPersonPhone: null, // 设计单位联系人电话
                    faxNumber: null, // 设计单位传真号码
                    officeNumber: null, // 设计单位办公号码
                    officeAddress: null, // 设计单位办公地址(营业地址)
                    registDate: null, // 设计单位注册日期
                    webSite: null, // 设计单位企业网址
                    email: null, // 设计单位企业邮箱
                    bankName: null, // 设计单位银行名称
                    bankAccount: null, // 设计单位银行卡号
                    bankBranchName: null, // 设计单位银行支行名称
                    bankAffiliated: null // 设计单位银行联号
                },
                orgSupervision: {
                    // 监理单位
                    orgName: null, // 监理单位企业事业单位名称
                    orgCreditCode: null, // 监理单位统一社会信用代码
                    projectManager: null, // 监理单位项目经理姓名
                    projectManagerPhone: null, // 监理单位项目经理联系电话
                    projectManagerIdCardNum: null, // 监理单位项目经理证件号码
                    principalName: null, // 参建单位项目责任人姓名
                    principalNamePhone: null, // 参建单位项目责任人联系电话
                    principalNameIdCardNum: null, // 参建单位项目责任人证件号码
                    constructionStatus: null, // 参建单位在项目中的承建状态
                    approachDate: null, // 监理单位进场时间
                    orgLicenseRegistCode: null, // 监理单位工商注册号
                    legalPersonName: null, // 监理单位法定代表人姓名
                    legalPersonIdCard: null, // 监理单位法定代表人证件号码
                    legalPersonPhone: null, // 监理单位法定代表人电话
                    legalPersonDuty: null, // 监理单位法定代表人职务
                    legalPersonProTitle: null, // 监理单位法定代表人职称
                    orgType: null, // 监理单位类型
                    economyType: null, // 监理单位经济类型
                    affiliation: null, // 监理单位隶属关系
                    operateType: null, // 监理单位经营方式
                    registerCapital: null, // 监理单位注册资本（ 元 ）
                    paidinCapital: null, // 监理单位实收资本（ 元 ）
                    capitalCurrency: 'CNY-人民币元', // 监理单位资本币种
                    registerDate: null, // 监理单位成立日期
                    registerAddressCode: null, // 监理单位注册地行政区划代码
                    registerAddress: null, // 注册地址
                    postalCode: null, // 监理单位邮政编码
                    registerType: null, // 监理单位登记注册类型
                    laborerPersonName: null, // 监理单位劳资负责人姓名
                    laborerPersonIdCard: null, // 监理单位劳资负责人公民身份证号码
                    laborerPersonPhone: null, // 监理单位劳资负责人联系电话
                    industry: null, // 监理单位所属行业
                    contactPerson: null, // 监理单位联系人姓名
                    contactPersonPhone: null, // 监理单位联系人电话
                    faxNumber: null, // 监理单位传真号码
                    officeNumber: null, // 监理单位办公号码
                    officeAddress: null, // 监理单位办公地址(营业地址)
                    registDate: null, // 监理单位注册日期
                    webSite: null, // 监理单位企业网址
                    email: null, // 监理单位企业邮箱
                    bankName: null, // 监理单位银行名称
                    bankAccount: null, // 监理单位银行卡号
                    bankBranchName: null, // 监理单位银行支行名称
                    bankAffiliated: null // 监理单位银行联号
                },
                orgSurvey: {
                    // 勘察单位
                    orgName: null, // 勘察单位企业事业单位名称
                    orgCreditCode: null, // 勘察单位统一社会信用代码
                    projectManager: null, // 勘察单位项目经理姓名
                    projectManagerPhone: null, // 勘察单位项目经理联系电话
                    projectManagerIdCardNum: null, // 勘察单位项目经理证件号码
                    principalName: null, // 参建单位项目责任人姓名
                    principalNamePhone: null, // 参建单位项目责任人联系电话
                    principalNameIdCardNum: null, // 参建单位项目责任人证件号码
                    constructionStatus: null, // 参建单位在项目中的承建状态
                    approachDate: null, // 勘察单位进场时间
                    orgLicenseRegistCode: null, // 勘察单位工商注册号
                    legalPersonName: null, // 勘察单位法定代表人姓名
                    legalPersonIdCard: null, // 勘察单位法定代表人证件号码
                    legalPersonPhone: null, // 勘察单位法定代表人电话
                    legalPersonDuty: null, // 勘察单位法定代表人职务
                    legalPersonProTitle: null, // 勘察单位法定代表人职称
                    orgType: null, // 勘察单位类型
                    economyType: null, // 勘察单位经济类型
                    affiliation: null, // 勘察单位隶属关系
                    operateType: null, // 勘察单位经营方式
                    registerCapital: null, // 监理单位注册资本（ 元 ）
                    paidinCapital: null, // 监理单位实收资本（ 元 ）
                    capitalCurrency: 'CNY-人民币元', // 勘察单位资本币种
                    registerDate: null, // 勘察单位成立日期
                    registerAddressCode: null, // 勘察单位注册地行政区划代码
                    registerAddress: null, // 注册地址
                    postalCode: null, // 勘察单位邮政编码
                    registerType: null, // 勘察单位登记注册类型
                    laborerPersonName: null, // 勘察单位劳资负责人姓名
                    laborerPersonIdCard: null, // 勘察单位劳资负责人公民身份证号码
                    laborerPersonPhone: null, // 勘察单位劳资负责人联系电话
                    industry: null, // 勘察单位所属行业
                    contactPerson: null, // 勘察单位联系人姓名
                    contactPersonPhone: null, // 勘察单位联系人电话
                    faxNumber: null, // 勘察单位传真号码
                    officeNumber: null, // 勘察单位办公号码
                    officeAddress: null, // 勘察单位办公地址(营业地址)
                    registDate: null, // 勘察单位注册日期
                    webSite: null, // 勘察单位企业网址
                    email: null, // 勘察单位企业邮箱
                    bankName: null, // 勘察单位银行名称
                    bankAccount: null, // 勘察单位银行卡号
                    bankBranchName: null, // 勘察单位银行支行名称
                    bankAffiliated: null // 勘察单位银行联号
                },
                projectSettlement: {
                    // 项目进度人工费用结算
                    constructionContractUrl: null, // 施工合同原件
                    settlementDate: null, // 工程进度人工费用累计结算日期
                    settlementCycle: null, // 工程进度人工费用累计结算周期
                    settlementAmount: null, // 工程进度人工费用累计结算金额
                },
                projectPaySecurity: {
                    // 项目工程款支付担保
                    securityOrgCode: null, // 担保单位统一社会信用代码
                    securityOrgName: null, // 担保单位名称
                    securityStartDate: null, // 担保开始日期
                    securityEndDate: null, // 担保结束日期
                    securityPrice: null, // 担保金额
                },
                constructionPermit: {
                    // 项目施工许可证
                    permitNumber: null, // 施工许可证号
                    permitStartDate: null, // 施工许可证发证日期
                    permitEndDate: null, // 施工许可证到期日期
                    permitUrl: null, // 施工许可证发证附件地址
                },
                showMap: false, // 地图坐标拾取
                mapInfo: {
                    lng: '',
                    lat: ''
                },
                projectId: '',
                contractAppendixList: [], // 合同图片列表
                constructionPermitList: [], // 施工许可证发证列表
                tripartiteAgreementList: [], // 工资专户三方协议图片列表
                securityPaymentsExemptUrlList: [], // 项目保障金附件列表
                dialogImageUrl: '',
                dialogVisible: false,
            };
        },
        components: {
            GDMaps
        },
        created() {
            this.fnInit();
        },
        watch: {
            project: {
                // 项目信息
                handler: function(_newVal) {
                    fnCookie('projectInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            orgGeneralContractor: {
                // 总承包单位
                handler: function(_newVal) {
                    fnCookie('orgGeneralContractorInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            orgOwner: {
                // 建设单位
                handler: function(_newVal) {
                    fnCookie('orgOwnerInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            wageAccount: {
                // 工资专户
                handler: function(_newVal) {
                    fnCookie('wageAccountInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            orgDesign: {
                // 设计单位
                handler: function(_newVal) {
                    fnCookie('orgDesignInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            orgSupervision: {
                // 监理单位
                handler: function(_newVal) {
                    fnCookie('orgSupervisionInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            orgSurvey: {
                // 勘察单位
                handler: function(_newVal) {
                    fnCookie('orgSurveyInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            projectSettlement: {
                // 项目进度人工费用结算
                handler: function(_newVal) {
                    fnCookie('projectSettlementInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            projectPaySecurity: {
                // 项目工程款支付担保
                handler: function(_newVal) {
                    fnCookie('projectPaySecurityInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
            constructionPermit: {
                // 项目进度人工费用结算
                handler: function(_newVal) {
                    fnCookie('constructionPermitInfoGzs:' + this.projectId, _newVal);
                },
                deep: true
            },
        },
        methods: {
            // 初始化函数
            fnInit() {
                this.projectId = getUserInfo().id
                this.fnGetAllUnit();
            },
            // 获取项目下所有参建单位
            fnGetAllUnit() {
                let _that = this;
                request({
                        url: 'project_gzs/getUnit',
                        method: 'GET',
                        params: {
                            type: '2,3,4,5,6,7,8,9,10,11'
                        }
                    })
                    .then(res => {
                        _that.tableData = [];
                        _that.projectData = res.data;
                        for (let i = 0; i < res.data.length; i++) {
                            let _data = res.data[i];

                            if (_data.type == 2) {
                                // 项目信息
                                _that.editProjectId = _data.id;
                                _that.tableData.push(_data);
                            } else if (_data.type == 3) {
                                // 工资专户
                                _that.editWageAccountId = _data.id;
                            } else if (_data.type == 4) {
                                // 总承包单位
                                _that.editOrgGeneralContractorId = _data.id;
                            } else if (_data.type == 5) {
                                // 设计单位
                                _that.editOrgDesignId = _data.id;
                            } else if (_data.type == 6) {
                                // 建设单位
                                _that.editOrgOwnerId = _data.id;
                            } else if (_data.type == 7) {
                                // 监理单位
                                _that.editOrgSupervisionId = _data.id;
                            } else if (_data.type == 8) {
                                // 勘察单位
                                _that.editOrgSurveyId = _data.id;
                            } else if (_data.type == 9) {
                                // 项目进度人工费用结算
                                _that.editProjectSettlementId = _data.id;
                            } else if (_data.type == 10) {
                                // 项目工程款支付担保
                                _that.editProjectPaySecurityId = _data.id;
                            } else if (_data.type == 11) {
                                // 项目施工许可证
                                _that.editConstructionPermitId = _data.id;
                            }
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 打开添加参建单位弹窗
            fnOpenAddWin() {
                this.isShowDetails = false;
                this.isEdit = false;

                let _projectInfoGzs = fnCookie('projectInfoGzs:' + this.projectId);
                let _orgGeneralContractor = fnCookie('orgGeneralContractorInfoGzs:' + this.projectId);
                let _orgOwner = fnCookie('orgOwnerInfoGzs:' + this.projectId);
                let _wageAccount = fnCookie('wageAccountInfoGzs:' + this.projectId);
                let _orgDesign = fnCookie('orgDesignInfoGzs:' + this.projectId);
                let _orgSupervision = fnCookie('orgSupervisionInfoGzs:' + this.projectId);
                let _orgSurvey = fnCookie('orgSurveyInfoGzs:' + this.projectId);
                let _projectSettlement = fnCookie('projectSettlementInfoGzs:' + this.projectId);
                let _projectPaySecurity = fnCookie('projectPaySecurityInfoGzs:' + this.projectId);
                let _constructionPermit = fnCookie('constructionPermitInfoGzs:' + this.projectId);

                // 回显填写信息
                this.project = _projectInfoGzs || this.project;
                this.orgGeneralContractor = _orgGeneralContractor || this.orgGeneralContractor;
                this.orgOwner = _orgOwner || this.orgOwner;
                this.wageAccount = _wageAccount || this.wageAccount;
                this.orgDesign = _orgDesign || this.orgDesign;
                this.orgSupervision = _orgSupervision || this.orgSupervision;
                this.orgSurvey = _orgSurvey || this.orgSurvey;
                this.projectSettlement = _projectSettlement || this.projectSettlement;
                this.projectPaySecurity = _projectPaySecurity || this.projectPaySecurity;
                this.constructionPermit = _constructionPermit || this.constructionPermit;

                this.showUnit = true;
            },
            // 打开编辑参建单位弹窗 --- 打开查看详情窗口
            fnOpenEditWin(_istrue) {
                let _that = this;
                _that.isEdit = true;
                _that.isShowDetails = _istrue; // false为编辑，true为详情
                for (let i = 0; i < _that.projectData.length; i++) {
                    let _data = _that.projectData[i];
                    let _thatData = null;

                    if (_data.type == 2) {
                        // 项目信息
                        _thatData = _that.project;
                    } else if (_data.type == 3) {
                        // 工资专户
                        _thatData = _that.wageAccount;
                    } else if (_data.type == 4) {
                        // 总承包单位
                        _thatData = _that.orgGeneralContractor;
                    } else if (_data.type == 5) {
                        // 设计单位
                        _thatData = _that.orgDesign;
                    } else if (_data.type == 6) {
                        // 建设单位
                        _thatData = _that.orgOwner;
                    } else if (_data.type == 7) {
                        // 监理单位
                        _thatData = _that.orgSupervision;
                    } else if (_data.type == 8) {
                        // 勘察单位
                        _thatData = _that.orgSurvey;
                    } else if (_data.type == 9) {
                        // 项目进度人工费用结算
                        _thatData = _that.projectSettlement;
                    } else if (_data.type == 10) {
                        // 项目工程款支付担保
                        _thatData = _that.projectPaySecurity;
                    } else if (_data.type == 11) {
                        // 项目施工许可证
                        _thatData = _that.constructionPermit;
                    }

                    for (let _key in _thatData) {

                        if (_data.type == 11 && _key == 'permitUrl') {
                            _that.constructionPermitList = []
                            let constructionPermitList = _data[_key] ? _data[_key].split(',') : []
                            constructionPermitList.forEach(e => {
                                _that.constructionPermitList.push({
                                    name: e,
                                    url: e
                                })
                            })

                        } else if (_data.type == 9 && _key == 'constructionContractUrl') {
                            _that.contractAppendixList = []
                            let contractAppendixList = _data[_key] ? _data[_key].split(',') : []
                            contractAppendixList.forEach(e => {
                                _that.contractAppendixList.push({
                                    name: e,
                                    url: e
                                })
                            })

                        } else if (_data.type == 3 && _key == 'tripartiteAgreementUrl') {
                            _that.tripartiteAgreementList = []
                            let tripartiteAgreementList = _data[_key] ? _data[_key].split(',') : []
                            tripartiteAgreementList.forEach(e => {
                                _that.tripartiteAgreementList.push({
                                    name: e,
                                    url: e
                                })
                            })

                        } else if (_data.type == 2 && _key == 'securityPaymentsExemptUrl') {
                            _that.securityPaymentsExemptUrlList = []
                            let securityPaymentsExemptUrlList = _data[_key] ? _data[_key].split(',') : []
                            securityPaymentsExemptUrlList.forEach(e => {
                                _that.securityPaymentsExemptUrlList.push({
                                    name: e,
                                    url: e
                                })
                            })

                        } else {
                            _thatData[_key] = _data[_key];
                        }
                    }
                }
                this.showUnit = true;
            },
            // 添加、编辑参建单位
            fnAddOrEdit() {
                let _that = this;
                let _index = 0;
                let _projectData = this.project; // 项目信息
                let _orgGeneralContractorData = this.orgGeneralContractor; // 参建单位
                let _orgOwnerData = this.orgOwner; // 建设单位
                let _wageAccountData = this.wageAccount; // 工资专户
                let _orgDesignData = this.orgDesign; // 设计单位
                let _orgSupervisionData = this.orgSupervision; // 监理单位
                let _orgSurveyData = this.orgSurvey; // 勘察单位
                let _projectSettlementData = this.projectSettlement; // 项目进度人工费用结算
                let _projectPaySecurityData = this.projectPaySecurity; // 项目工程款支付担保
                let _constructionPermitData = this.constructionPermit; // 项目施工许可证

                // 项目所需验证信息
                let _projectNeedField = {
                    category: '项目分类',
                    govInvest: '是否政府投资项目',
                    isRegistered: '是否在贵州省建筑业监管和公共服务平台备案',
                    projectAddress: '项目所在地',
                    projectDetailedAddress: '项目地址',
                    lon: '经度',
                    lat: '纬度',
                    status: '项目状态',
                    contractSigningDate: '项目合同签订日期',
                    contractPrice: '签约合同价（万元）',
                    planStartDate: '项目（计划）开工日期',
                    planCompleteDate: '项目（计划）开工日期',
                    startDate: '项目（实际）开工日期',
                    // completeDate: '项目（实际）竣工日期',
                    linkPersonName: '联系人姓名',
                    linkPersonPhone: '联系人电话',
                    subordinateDepartments: '所属行政主管部门',
                    isInsurance: '是否购买工伤保险',
                    securityPayments: '项目保障金预存金额，最低5万，单位为万元',
                    labourSpecialName: '劳资专管员姓名',
                    labourSpecialPhone: '劳资专管员电话',
                    labourSpecialIdCard: '劳资专管员身份证号码',
                    payDate: '发薪日期',
                    safeguardCertificateUrl: '维权告示牌凭证',
                    securityPaymentsType: '项目保障金类型'
                };

                // 总承包单位所需验证信息
                let _orgGeneralContractorNeedField = {
                    projectManager: '总承包单位项目经理姓名',
                    projectManagerPhone: '总承包单位项目经理联系电话',
                    projectManagerIdCardNum: '总承包单位项目经理证件号码',
                    principalName: '总承包单位项目责任人姓名',
                    principalNamePhone: '总承包单位项目责任人联系电话',
                    principalNameIdCardNum: '总承包单位项目责任人证件号码',
                    constructionStatus: '总承包单位在项目中的承建状态',
                    approachDate: '进场时间',
                    orgName: '企业事业单位名称',
                    orgCreditCode: '统一社会信用代码',
                    registerAddress: '注册地址',

                    legalPersonName: '法定代表人姓名',
                    legalPersonIdCard: '法定代表人证件号码',
                    legalPersonPhone: '法定代表人电话',

                    registerAddressCode: '注册地行政区划代码',
                    registerAddress: '注册地址',
                    postalCode: '邮政编码',
                    laborerPersonName: '劳资负责人姓名',
                    laborerPersonIdCard: '劳资负责人公民身份证号码',
                    laborerPersonPhone: '劳资负责人联系电话',
                    contactPerson: '联系人姓名',
                    contactPersonPhone: '联系人电话',
                    officeAddress: '办公地址(营业地址)',
                    registDate: '注册日期',
                    orgType:'单位类型',
                    registerCapital:'注册资本',
                };

                // 建设单位所需验证信息
                let _orgOwnerNeedField = {
                    orgName: '企业事业单位名称',
                    orgCreditCode: '统一社会信用代码',
                    legalPersonName: '法定代表人姓名',
                    legalPersonIdCard: '法定代表人证件号码',
                    legalPersonPhone: '法定代表人电话',
                    registerAddressCode: '注册地行政区划代码',
                    registerAddress: '注册地址',
                    postalCode: '邮政编码',
                    laborerPersonName: '劳资负责人姓名',
                    laborerPersonIdCard: '劳资负责人公民身份证号码',
                    laborerPersonPhone: '劳资负责人联系电话',
                    contactPerson: '联系人姓名',
                    contactPersonPhone: '联系人电话',
                    officeAddress: '办公地址(营业地址)',
                    registDate: '注册日期',
                    orgType:'单位类型',
                    registerCapital:'注册资本',
                };

                // 参建单位所需验证信息
                let _orgOwnersNeedField = {
                    orgName: '企业事业单位名称',
                    orgCreditCode: '统一社会信用代码',
                    principalName: '参建单位项目责任人姓名',
                    principalNamePhone: '参建单位项目责任人联系电话',
                    principalNameIdCardNum: '参建单位项目责任人证件号码',
                    constructionStatus: '参建单位在项目中的承建状态',
                    legalPersonName: '法定代表人姓名',
                    legalPersonIdCard: '法定代表人证件号码',
                    legalPersonPhone: '法定代表人电话',
                    registerAddressCode: '注册地行政区划代码',
                    registerAddress: '注册地址',
                };

                // 工资专户所需验证信息
                let _wageAccountNeedField = {
                    bank: '所属银行',
                    accountName: '开户名称',
                    accountType: '开户类型',
                    specialAccountType: '专户类型',
                    salaryPayChannel: '工资发放渠道',
                    accountNo: '开户账号',
                    bankName: '开户银行支行名称',
                    accountBalance: '账户余额（元）'
                };

                // 项目进度人工费用结算
                let _projectSettlementNeedField = {
                    constructionContractUrl: '施工合同原件',
                    settlementDate: '工程进度人工费用累计结算日期',
                    settlementCycle: '工程进度人工费用累计结算周期',
                    settlementAmount: '工程进度人工费用累计结算金额'
                };

                // 项目工程款支付担保
                let _projectPaySecurityNeedField = {
                    securityOrgCode: '担保单位统一社会信用代码',
                    securityOrgName: '担保单位名称',
                    securityStartDate: '担保开始日期',
                    securityEndDate: '担保结束日期',
                    securityPrice: '担保金额',
                };

                // 项目施工许可证
                let _constructionPermitNeedField = {
                    permitNumber: '施工许可证号',
                    permitStartDate: '施工许可证发证日期',
                    permitEndDate: '施工许可证到期日期',
                    // permitUrl: '施工许可证发证原件',
                };

                for (let _key in _projectNeedField) {
                    if (_projectData[_key] == '' || _projectData[_key] == null) {
                        this.$message.warning('项目信息中' + _projectNeedField[_key] + '不能为空');
                        return;
                    }
                }

                if (this.securityPaymentsExemptUrlList) {
                    // 处理项目保障金附件
                    let securityPaymentsExemptUrlList = this.securityPaymentsExemptUrlList.map(e => {
                        return e.url
                    })
                    _projectData.securityPaymentsExemptUrl = securityPaymentsExemptUrlList.join(',')
                }


                for (let _key in _orgGeneralContractorNeedField) {
                    if (_orgGeneralContractorData[_key] == '' || _orgGeneralContractorData[_key] == null) {
                        this.$message.warning('总承包单位信息中' + _orgGeneralContractorNeedField[_key] + '不能为空');
                        return;
                    }
                }

                for (let _key in _orgOwnerNeedField) {
                    if (_orgOwnerData[_key] == '' || _orgOwnerData[_key] == null) {
                        this.$message.warning('建设单位信息中' + _orgOwnerNeedField[_key] + '不能为空');
                        return;
                    }
                }

                // 工资专户信息验证
                let _wageAccountCheck = false;
                let _wageAccountCheckKey = null;
                for (let _key in _wageAccountNeedField) {
                    if (_wageAccountData[_key] == '' || _wageAccountData[_key] == null) {
                        _wageAccountCheckKey = _key;
                        if (_wageAccountCheck) break;
                    } else {
                        _wageAccountCheck = true;
                    }
                }
                if (_wageAccountCheck && _wageAccountCheckKey) {
                    this.$message.warning('工资专户信息中' + _wageAccountNeedField[_wageAccountCheckKey] + '不能为空');
                    return;
                }
                if (this.tripartiteAgreementList) {
                    // 处理工资专户三方协议附件
                    let tripartiteAgreementList = this.tripartiteAgreementList.map(e => {
                        return e.url
                    })
                    _wageAccountData.tripartiteAgreementUrl = tripartiteAgreementList.join(',')
                }

                // 设计单位信息验证
                let _orgDesignCheck = false;
                let _orgDesignCheckKey = null;
                for (let _key in _orgOwnersNeedField) {
                    if (_orgDesignData[_key] == '' || _orgDesignData[_key] == null) {
                        _orgDesignCheckKey = _key;
                        if (_orgDesignCheck) break;
                    } else {
                        _orgDesignCheck = true;
                    }
                }
                if (_orgDesignCheck && _orgDesignCheckKey) {
                    this.$message.warning('设计单位信息中' + _orgOwnersNeedField[_orgDesignCheckKey] + '不能为空');
                    return;
                }

                // 监理单位信息验证
                let _orgSupervisionCheck = false;
                let _orgSupervisionCheckKey = null;
                for (let _key in _orgOwnersNeedField) {
                    if (_orgSupervisionData[_key] == '' || _orgSupervisionData[_key] == null) {
                        _orgSupervisionCheckKey = _key;
                        if (_orgSupervisionCheck) break;
                    } else {
                        _orgSupervisionCheck = true;
                    }
                }
                if (_orgSupervisionCheck && _orgSupervisionCheckKey) {
                    this.$message.warning('监理单位信息中' + _orgOwnersNeedField[_orgSupervisionCheckKey] + '不能为空');
                    return;
                }

                // 勘察单位信息验证
                let _orgSurveyCheck = false;
                let _orgSurveyCheckKey = null;
                for (let _key in _orgOwnersNeedField) {
                    if (_orgSurveyData[_key] == '' || _orgSurveyData[_key] == null) {
                        _orgSurveyCheckKey = _key;
                        if (_orgSurveyCheck) break;
                    } else {
                        _orgSurveyCheck = true;
                    }
                }
                if (_orgSurveyCheck && _orgSurveyCheckKey) {
                    this.$message.warning('勘察单位信息中' + _orgOwnersNeedField[_orgSurveyCheckKey] + '不能为空');
                    return;
                }

                // 项目进度人工费用结算
                if (this.contractAppendixList) {
                    // 处理合同附件
                    let contractAppendixList = this.contractAppendixList.map(e => {
                        return e.url
                    })
                    _projectSettlementData.constructionContractUrl = contractAppendixList.join(',')
                }
                let _projectSettlementCheck = false;
                let _projectSettlementCheckKey = null;
                for (let _key in _projectSettlementNeedField) {
                    if (_projectSettlementData[_key] == '' || _projectSettlementData[_key] == null) {
                        _projectSettlementCheckKey = _key;
                        if (_projectSettlementCheck) break;
                    } else {
                        _projectSettlementCheck = true;
                    }
                }
                if (_projectSettlementCheck && _projectSettlementCheckKey) {
                    this.$message.warning('项目进度人工费用结算中' + _projectSettlementNeedField[_projectSettlementCheckKey] +
                        '不能为空');
                    return;
                }


                // 项目工程款支付担保
                let _projectPaySecurityCheck = false;
                let _projectPaySecurityCheckKey = null;
                for (let _key in _projectPaySecurityNeedField) {
                    if (_projectPaySecurityData[_key] == '' || _projectPaySecurityData[_key] == null) {
                        _projectPaySecurityCheckKey = _key;
                        if (_projectPaySecurityCheck) break;
                    } else {
                        _projectPaySecurityCheck = true;
                    }
                }
                if (_projectPaySecurityCheck && _projectPaySecurityCheckKey) {
                    this.$message.warning('项目工程款支付担保中' + _projectPaySecurityNeedField[_projectPaySecurityCheckKey] +
                        '不能为空');
                    return;
                }

                // 项目施工许可证
                if (this.constructionPermitList) {
                    // 处理合同附件
                    let constructionPermitList = this.constructionPermitList.map(e => {
                        return e.url
                    })
                    _constructionPermitData.permitUrl = constructionPermitList.join(',')
                }
                let _constructionPermitCheck = false;
                let _constructionPermitCheckKey = null;
                for (let _key in _constructionPermitNeedField) {
                    if (_constructionPermitData[_key] == '' || _constructionPermitData[_key] == null) {
                        _constructionPermitCheckKey = _key;
                        if (_constructionPermitCheck) break;
                    } else {
                        _constructionPermitCheck = true;
                    }
                }
                if (_constructionPermitCheck && _constructionPermitCheckKey) {
                    this.$message.warning('项目施工许可证中' + _constructionPermitNeedField[_constructionPermitCheckKey] +
                        '不能为空');
                    return;
                }

                if (this.project.projectAddress.length !== 12) {
                    this.$message.warning('项目所在地行政区划代码应为12位,不足则以0补足12位');
                    return;
                }

                const reg = /^1[3-9]\d{9}$/;
                if (!reg.test(this.project.linkPersonPhone)) {
                    this.$message.warning('请输入正确的项目联系人电话');
                    return;
                }

                if (!reg.test(this.project.labourSpecialPhone)) {
                    this.$message.warning('请输入正确的项目劳资专管员电话');
                    return;
                }

                if (this.project.labourSpecialIdCard.length !== 18) {
                    this.$message.warning('项目劳资专管员身份证号码长度应为18位');
                    return;
                }

                if (!reg.test(this.orgGeneralContractor.projectManagerPhone)) {
                    this.$message.warning('请输入正确的总承包单位参建单位项目经理联系电话');
                    return;
                }

                if (this.orgGeneralContractor.projectManagerIdCardNum.length !== 18) {
                    this.$message.warning('参建单位项目经理身份证号码长度应为18位');
                    return;
                }

                if (this.orgGeneralContractor.orgCreditCode.length !== 18) {
                    this.$message.warning('总承包单位统一社会信用代码长度应为18位');
                    return;
                }

                if (this.orgOwner.orgCreditCode.length !== 18) {
                    this.$message.warning('建设单位统一社会信用代码长度应为18位');
                    return;
                }

                _projectData['type'] = 2; // 项目信息
                _orgGeneralContractorData['type'] = 4; // 参建单位
                _orgOwnerData['type'] = 6; // 建设单位

                _wageAccountData['type'] = 3; // 工资专户
                _orgDesignData['type'] = 5; // 设计单位
                _orgSupervisionData['type'] = 7; // 监理单位
                _orgSurveyData['type'] = 8; // 勘察单位
                _projectSettlementData['type'] = 9; // 项目进度人工费用结算
                _projectPaySecurityData['type'] = 10; // 项目进度人工费用结算
                _constructionPermitData['type'] = 11; // 项目施工许可证

                if (this.isEdit) {
                    _projectData['id'] = _that.editProjectId;
                    _orgGeneralContractorData['id'] = _that.editOrgGeneralContractorId;
                    _orgOwnerData['id'] = _that.editOrgOwnerId;

                    _wageAccountData['id'] = _that.editWageAccountId ? _that.editWageAccountId : null;
                    _orgDesignData['id'] = _that.editOrgDesignId ? _that.editOrgDesignId : null;
                    _orgSupervisionData['id'] = _that.editOrgSupervisionId ? _that.editOrgSupervisionId : null;
                    _orgSurveyData['id'] = _that.editOrgSurveyId ? _that.editOrgSurveyId : null;
                    _projectSettlementData['id'] = _that.editProjectSettlementId ? _that.editProjectSettlementId : null;
                    _projectPaySecurityData['id'] = _that.editProjectPaySecurityId ? _that.editProjectPaySecurityId :
                        null;
                    _constructionPermitData['id'] = _that.editConstructionPermitId ? _that.editConstructionPermitId :
                        null;
                }

                let _data = {
                    projectData: _projectData,
                    orgGeneralContractorData: _orgGeneralContractorData,
                    orgOwnerData: _orgOwnerData
                };
                if (_wageAccountCheck) {
                    _data['wageAccountData'] = _wageAccountData;
                }
                if (_orgDesignCheck) {
                    _data['orgDesignData'] = _orgDesignData;
                }
                if (_orgSupervisionCheck) {
                    _data['orgSupervisionData'] = _orgSupervisionData;
                }
                if (_orgSurveyCheck) {
                    _data['orgSurveyData'] = _orgSurveyData;
                }
                if (_projectSettlementCheck) {
                    _data['projectSettlementData'] = _projectSettlementData;
                }
                if (_projectPaySecurityCheck) {
                    _data['projectPaySecurityData'] = _projectPaySecurityData;
                }
                if (_constructionPermitCheck) {
                    _data['constructionPermitData'] = _constructionPermitData;
                }

                for (let _key in _data) {
                    _fn(_data[_key], res => {
                        if (_index == Object.keys(_data).length) {
                            _that.$message.success(res.data);
                            _that.showUnit = false;
                            _that.fnInit();

                            fnCookie('projectInfoGzs:' + _that.projectId, '');
                            fnCookie('orgGeneralContractorInfoGzs:' + _that.projectId, '');
                            fnCookie('orgOwnerInfoGzs:' + _that.projectId, '');
                            fnCookie('wageAccountInfoGzs:' + _that.projectId, '');
                            fnCookie('orgDesignInfoGzs:' + _that.projectId, '');
                            fnCookie('orgSupervisionInfoGzs:' + _that.projectId, '');
                            fnCookie('orgSurveyInfoGzs:' + _that.projectId, '');
                            fnCookie('projectSettlementInfoGzs:' + _that.projectId, '');
                            fnCookie('projectPaySecurityInfoGzs:' + _that.projectId, '');
                            fnCookie('constructionPermitInfoGzs:' + _that.projectId, '');

                            _that.fnGetAllUnit();
                        }
                    });
                }

                function _fn(_data, _cb) {
                    request({
                            url: 'project_gzs/addOrEditUnit',
                            method: 'POST',
                            data: _data
                        })
                        .then(res => {
                            ++_index;
                            _cb && _cb(res);
                        })
                        .catch(err => {
                            // _that.showUnit = false;
                            _that.$message.error(err.data);
                        });
                }
            },
            // 删除参建单位
            fnDeleteUnit(_id) {
                request({
                        url: 'Project/deleteUnit',
                        method: 'POST',
                        data: {
                            id: _id
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.fnInit();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 上传项目信息至贵州省人社厅
            fnUploadProjectToGzs() {
                fnRequestPlatform({
                        url: '/Gzs/uploadProjectInfo',
                        method: 'GET'
                    },
                    res => {
                        if (res.code == APP.HTTP_STATUS.SUCCESS) {
                            this.$message.success(res.data);
                            this.fnInit();
                        } else {
                            this.$message.error(res.data);
                        }
                    }
                );
            },
            // 上传图片
            beforeCardPicUpload(_file, _el) {
                let _loadingInstance = Loading.service({
                    fullscreen: true,
                    background: 'rgba(255,255,255,0.7)',
                    spinner: 'el-icon-loading',
                    text: '图片上传中…'
                });
                let _that = this;
                imageConversion.compressAccurately(_file, 200).then(_res => {
                    let reader = new FileReader();
                    reader.onload = function() {
                        let _base64 = this.result;
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile(_base64);
                        let formData = new FormData();

                        formData.append('file', _fileObject);
                        formData.append('type', 'image');

                        if (_base64.indexOf('data:image/') != -1) {
                            _base64 = _base64.split(',')[1];
                        }

                        fnUpload(formData, res => {
                            if (_el == 'constructionPermit') {
                                _that.constructionPermitList.push({
                                    "name": _file.name,
                                    "url": res.data.file_url
                                })
                            } else if (_el == 'contractAppendix') {
                                _that.contractAppendixList.push({
                                    "name": _file.name,
                                    "url": res.data.file_url
                                })
                            } else if (_el == 'tripartiteAgreement') {
                                _that.tripartiteAgreementList.push({
                                    "name": _file.name,
                                    "url": res.data.file_url
                                })
                            } else if (_el == 'securityPaymentsExemptUrl') {
                                _that.securityPaymentsExemptUrlList.push({
                                    "name": _file.name,
                                    "url": res.data.file_url
                                })
                            } else {
                                _that.project[_el] = res.data.file_url;
                            }
                            _loadingInstance.close();
                        });
                    };
                    reader.readAsDataURL(_res);
                });
                return false; // 阻止组件自动上传图片
            },
            // 跳转坐标拾取 子传父
            fnGetLocation(lng, lat) {
                this.mapInfo.lng = lng;
                this.mapInfo.lat = lat;
            },
            // 确认选择的经纬度 关闭弹窗
            fnGetLocationYes() {
                this.project.lon = this.mapInfo.lng;
                this.project.lat = this.mapInfo.lat;
                this.showMap = false;
            },
            // 删除图片
            handleRemove(file, fileList) {
                let arr = []
                this.contractAppendixList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.contractAppendixList = arr
            },
            // 删除图片
            handleRemove2(file, fileList) {
                let arr = []
                this.tripartiteAgreementList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.tripartiteAgreementList = arr
            },
            // 删除图片
            handleRemove3(file, fileList) {
                let arr = []
                this.securityPaymentsExemptUrlList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.securityPaymentsExemptUrlList = arr
            },
            // 删除图片
            handleRemove4(file, fileList) {
                let arr = []
                this.constructionPermitList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.constructionPermitList = arr
            },
            // 查看合同图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            }
        }
    };
</script>
<style scoped lang="scss" type="text/scss">
    @import '~@/styles/mixin.scss';
.project_info_box {
    width: 1920px;
    height: 858px;
    position: relative;
    overflow: hidden;
    .project_info {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
.search_box {
    height: 32px;
    width: 1880px;
    margin-top: 24px;
    margin-left: 20px;
    @include flex-box(space-between, center, column);
    .box_line {
        width: 1880px;
        height: 32px;
        @include flex-box(flex-start, center);
        .line_input {
            min-width: 280px;
            height: 30px;
            margin-right: 10px;
            border-top-right-radius: 1px;
            border-bottom-right-radius: 1px;
            background-color: rgba(49, 88, 128, 0.4);
            @include flex-box(flex-start, center);
            .input_title {
                width: 69px;
                height: 30px;
                font-size: 14px;
                color: #9bf9fc;
                border-radius: 2px;
                background-color: rgba(155, 249, 252, 0.1);
                @include flex-box(center, center);
            }
        }
    }
}
.cont_list {
    margin-top: 29px;
    margin-left: 28px;
    width: 1864px;
    height: 773px;
    border-radius: 10px;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
        width: 1864px;
        height: 48px;
        background: url(../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        @include flex-box(flex-start, center);
        .title_item {
            height: 48px;
            @include flex-box(center, center);
            &:nth-child(1) {
                width: 161px;
                margin: 0 4px 0 40px;
            }
            &:nth-child(2) {
                width: 151px;
                margin-right: 4px;
            }
            &:nth-child(3) {
                width: 241px;
                margin-right: 4px;
            }
            &:nth-child(4) {
                width: 131px;
                margin-right: 4px;
            }
            &:nth-child(5) {
                width: 300px;
                margin-right: 4px;
            }
            &:nth-child(6) {
                width: 300px;
                margin-right: 4px;
            }
            &:nth-child(7) {
                width: 309px;
                margin-right: 4px;
            }
            &:nth-child(8) {
                width: 153px;
                margin-right: 40px;
            }
        }
    }
    .list_boxes {
        width: 1864px;
        height: 725px;
        position: relative;
        overflow: hidden;
        .list_box {
            position: absolute;
            left: 0;
            right: -25px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            .box_line {
                width: 1784px;
                height: 70px;
                margin: 7px 0 0 40px;
                font-size: 16px;
                color: #ffffff;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(flex-start, center);
                &:hover {
                    background-color: rgba(49, 88, 128, 0.4);
                }
                .list_item {
                    height: 70px;
                    text-align: center;
                    @include flex-box(center, center);
                    &:nth-child(1) {
                        width: 161px;
                        margin-right: 4px;
                    }
                    &:nth-child(2) {
                        width: 151px;
                        margin-right: 4px;
                    }
                    &:nth-child(3) {
                        width: 241px;
                        margin-right: 4px;
                    }
                    &:nth-child(4) {
                        width: 131px;
                        margin-right: 4px;
                    }
                    &:nth-child(5) {
                        width: 300px;
                        margin-right: 4px;
                    }
                    &:nth-child(6) {
                        width: 300px;
                        margin-right: 4px;
                    }
                    &:nth-child(7) {
                        width: 309px;
                        margin-right: 4px;
                    }
                    &:nth-child(8) {
                        width: 153px;
                    }
                    div {
                        @include flex-box(center, center);
                    }
                    span {
                        width: 100%;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}
.wrap-project {
    @include flex-box();
    .btn_line {
        @include flex-box(center, center);
    }
    >>> .el-dialog {
        width: auto;
        height: auto;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-form-item__label {
        color: #4db4f4;
    }
    >>> .el-dialog__title {
        color: #4db4f4;
    }
    >>> .el-dialog__close {
        color: #4db4f4;
    }
    >>> .el-tabs__item.is-active {
        color: #409eff !important;
    }
    >>> .el-input__inner {
        width: 300px;
        height: 30px;
        border-radius: 2px;
        border: none;
        background-color: rgba(77, 180, 244, 0.2);
        color: rgba(77, 180, 244, 0.9);
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-select {
        .el-input {
            .el-select__caret {
                color: rgba(77, 180, 244, 0.7);
            }
        }
    }
    >>> .el-select-dropdown {
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(77, 180, 244, 1);
    }
    >>> .popper__arrow {
        border-bottom-color: rgba(77, 180, 244, 1) !important;
    }
    >>> .el-select-dropdown__item {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-select-dropdown__item:hover {
        color: #409eff;
    }
    >>> .el-select-dropdown__item.hover {
        color: #409eff;
    }
    >>> .el-input__icon {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-range-input {
        color: rgba(77, 180, 244, 0.7);
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-range-separator {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-tabs__item {
        color: white;
    }
    .pane_box {
        @include flex-box();
        .item {
            border: 1px solid rgba(77, 180, 244, 0.7);
            &:last-of-type {
                .row {
                    &:last-of-type {
                        border-bottom: 1px solid rgba(77, 180, 244, 0.7);
                    }
                }
            }
            .row {
                min-height: 51px;
                line-height: 36px;
                border-bottom: 1px solid rgba(77, 180, 244, 0.7);
                @include flex-box();
                &:last-of-type {
                    border-bottom: 0;
                }
                .row-item {
                    color: rgba(255, 255, 255, 0.8);
                    padding: 5px 0 5px 15px;
                    @include flex-item();
                    &:first-of-type {
                        border-right: 1px solid rgba(77, 180, 244, 0.7);
                    }
                    .el-input {
                        max-width: 300px;
                    }
                }
            }
            &.left-item {
                @include flex-item();
                .row:last-of-type {
                    border-bottom: 1px solid rgba(77, 180, 244, 0.7);
                }
            }
            &.right-item {
                @include flex-item();
                .row:last-of-type {
                    border-bottom: 1px solid rgba(77, 180, 244, 0.7);
                }
                >>> .avatar-uploader {
                    line-height: 100px;
                    margin-right: 10px;
                    img {
                        width: 98px;
                        height: 98px;
                        border-radius: 2px;
                    }
                }

                >>> .el-upload {
                    width: 100px;
                    height: 100px;
                    line-height: 100px;
                }
            }
        }
    }
}

>>> .avatar-uploader-s {
  li {
    width: 100px;
    height: 100px;
  }
}
>>> .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
}

.dialog_setMap {
    >>> .el-dialog {
        width: 720px;
        height: 620px;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-dialog__body {
        padding: 10px;
        height: 510px;
    }
    >>> .el-form-item__label {
        color: #4db4f4;
    }
    >>> .el-dialog__title {
        color: #4db4f4;
    }
    >>> .el-dialog__close {
        color: #4db4f4;
    }
    .btn_line {
        @include flex-box(center, center);
    }
    .show_map {
        width: 700px;
        height: 490px;
        z-index: 100;
        overflow: hidden;
        color: #4db4f4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectInfo/ProjectInfoGzs/index.vue